/**
 * Validateurs génériques
 */

/**
 * Vérifie qu'une chaîne n'est pas vide (après trim)
 */
export function isNotEmpty(value: string): boolean {
  return value.trim().length > 0;
}

/**
 * Vérifie qu'un nombre est positif
 */
export function isPositive(value: number): boolean {
  return value > 0;
}

/**
 * Vérifie qu'un nombre est dans un intervalle
 */
export function isInRange(value: number, min: number, max: number): boolean {
  return value >= min && value <= max;
}

/**
 * Vérifie le format d'un numéro de compte
 * Accepte les numéros de 10 à 20 chiffres (CBS utilise 17 chiffres)
 */
export function isValidAccountNumber(accountNumber: string): boolean {
  const pattern = /^\d{10,20}$/;
  return pattern.test(accountNumber);
}

/**
 * Vérifie le format d'un numéro de téléphone ivoirien
 * Formats acceptés: 0708090102, +2250708090102, 2250708090102
 */
export function isValidPhoneNumber(phone: string): boolean {
  const cleaned = phone.replace(/\s/g, '');
  const patterns = [
    /^0[0-9]{9}$/,           // 0708090102
    /^\+225[0-9]{10}$/,      // +2250708090102
    /^225[0-9]{10}$/,        // 2250708090102
  ];
  return patterns.some(pattern => pattern.test(cleaned));
}

/**
 * Vérifie qu'une date n'est pas dans le futur
 */
export function isNotFutureDate(date: Date): boolean {
  return date <= new Date();
}

/**
 * Vérifie qu'une date n'est pas expirée
 */
export function isNotExpired(date: Date): boolean {
  return date >= new Date();
}

/**
 * Vérifie le format d'un numéro de CNI ivoirienne
 */
export function isValidCNI(cni: string): boolean {
  // Format CNI ivoirienne: lettres et chiffres, longueur variable
  return cni.length >= 6 && cni.length <= 20;
}

/**
 * Vérifie le format d'un email
 */
export function isValidEmail(email: string): boolean {
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return pattern.test(email);
}

/**
 * Vérifie qu'une valeur n'est ni null ni undefined
 */
export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

/**
 * Vérifie qu'un tableau n'est pas vide
 */
export function isArrayNotEmpty<T>(array: T[]): boolean {
  return Array.isArray(array) && array.length > 0;
}
